import { render, staticRenderFns } from "./CloseButton.vue?vue&type=template&id=68c5aa08&scoped=true&"
import script from "./CloseButton.vue?vue&type=script&lang=ts&"
export * from "./CloseButton.vue?vue&type=script&lang=ts&"
import style0 from "./CloseButton.vue?vue&type=style&index=0&id=68c5aa08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c5aa08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VHover,VIcon,VTooltip})
